import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=aae56a1a&scoped=true&"
import script from "./transferRecord.vue?vue&type=script&lang=js&"
export * from "./transferRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae56a1a",
  null
  
)

export default component.exports